import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import { getFirstRunTimeStamp } from "@/utils/user/first-run-timestamp";
import { initFirebase } from './init';

async function main() {
    try {
        if (localStorage.getItem('firstRunTSFS') !== null) return;

        initFirebase();

        const db = firebase.firestore()
        const usersRef = db.collection('users')
        let firstRunTSFS = getFirstRunTimeStamp()
        const deviceId = localStorage.getItem('deviceId') || ''
        const deviceOs = localStorage.getItem('deviceOs') || ''
        const isPhysicalDevice = localStorage.getItem('isPhysicalDevice') || ''

        if (deviceId === '') {
            // Prevent log on development.
            const isDev = (process.env.NODE_ENV === 'development' || location.hostname === "localhost" || location.hostname.includes("192.168.0.") || location.hostname.includes("test.app."));

            // return !isDev
            //     ? captureException(new Error('Device ID not found'))
            //     : null

            return null
        }

        const snapshot = await usersRef.doc(deviceId).get()

        if (snapshot.exists) {
            // @ts-ignore
            const { firstRunTS } = snapshot.data();

            if (firstRunTSFS > firstRunTS) firstRunTSFS = firstRunTS

            localStorage.setItem('firstRunTSFS', String(firstRunTSFS))
            app.$bus.$emit("flutter:updateFirstRunTS")
        }

        if (!snapshot.exists) {
            await usersRef.doc(deviceId).set({
                deviceId, deviceOs, isPhysicalDevice, firstRunTS: getFirstRunTimeStamp() || Date.now(),
            })
        }
    } catch (error) {
        captureException(error)
    }
}

main()
